"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentModule = void 0;
const inversify_1 = require("inversify");
/**
 * Module to retrieve content used by the client applications
 *
 * TODO: should probably add other content related stuff like courses, articles, resources, news here
 */
let ContentModule = class ContentModule {
    constructor(_httpConnection) {
        this._httpConnection = _httpConnection;
    }
    async retrieveMarketingItems() {
        const { marketingItems } = await this._httpConnection.makeRequest({
            url: "marketing",
            method: "get"
        });
        return marketingItems || [];
    }
};
ContentModule = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)("HttpConnection"))
], ContentModule);
exports.ContentModule = ContentModule;
//# sourceMappingURL=ContentModule.js.map